import Footer from "../../components/molecules/footer/Footer";
import Header from "../../components/molecules/header/Header";
import { logout } from "../../components/services/LoginService";

const TokenExpirado = () => {

    return (<>
        <Header />
        <div className="container mt-5 vh-100">

            <div className="alert alert-warning" role="alert">
                Su sesión ha expirado. Por favor, inicie sesión de nuevo.
            </div>
            <div className="button row d-flex justify-content-center">
                <div className="col-3">
                    <button className="btn rounded btn-primary mb-4 py-2" onClick={() => {
                        logout();
                        localStorage.setItem("breadcrumbsHistory", "");
                        window.location.href = "/login"
                    }}>
                        Acceder
                    </button>
                </div>

            </div>
        </div>
        <Footer />
    </>
    );
}

export default TokenExpirado;